module.exports = __webpack_public_path__ + "static/trips-content-1-80f4f6553610f098472e37b19656f34d.png";